<template>
  <div>
    <v-overlay opacity="0.8" v-if="chips >= maxChips && chipWarning == true">
      <v-row justify="center" class="text-break">
        <h3>
          You have reached the maximum amount of chips you can create ( {{ chips }} /
          {{ maxChips }} )
        </h3>
      </v-row>
      <v-row justify="center" class="text-break">
        <h3>You will need to delete one of your existing chips to save another one</h3>
      </v-row>
      <v-row class="mt-4" justify="center">
        <v-btn class="mx-2" :color="config.primary" @click="chipWarning = false">
          Continue Anyway
        </v-btn>
        <v-btn class="mx-2" :color="config.confirm" @click="$router.push({ name: 'created' })">
          Go my chips
        </v-btn>
      </v-row>
    </v-overlay>
    <v-overlay opacity="0.8" v-if="chromeWarning == true">
      <v-row justify="center">
        <h3>It is recommended to use the Chrome browser for this application.</h3>
      </v-row>
      <v-row justify="center">
        <h3>You may encounter issues if you are using</h3>
      </v-row>
      <v-row justify="center">
        <h3>a different browser.</h3>
      </v-row>
      <v-row class="mt-4" justify="center">
        <v-btn :color="config.primary" @click="chromeWarning = false">
          Continue Anyway
        </v-btn>
      </v-row>
    </v-overlay>
    <v-overlay opacity="0.8" v-if="sizeWarningDialog == true && chromeWarning == false">
      <v-row justify="center">
        <h3>Please resize the window to get the best experience</h3>
      </v-row>
      <v-row justify="center">
        <h3>It is not recommended to use a mobile device.</h3>
      </v-row>
      <v-row class="mt-4" justify="center">
        <v-btn
          :color="config.primary"
          @click=";(sizeWarningDialog = false), (enableSizeWarning = false)"
        >
          Continue Anyway
        </v-btn>
      </v-row>
    </v-overlay>
    <div class="flex-container" id="clickable">
      <div class="left-container">
        <div class="side-settings-element">
          <v-card
            class="settings-card"
            elevation="4"
            :dark="config.dark_background"
            :color="config.background_dark_slight"
          >
            <v-container>
              <v-row justify="center">
                <v-col cols="12" sm="11">
                  <v-row justify="center" class="mb-4">
                    <h2>Insert Elements</h2>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      block
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      tile
                      x-large
                      @click="addElement('textbox'), toggleDrawMode(false)"
                    >
                      <v-icon left>mdi-format-text</v-icon>
                      <span>Textbox</span>
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      block
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      tile
                      x-large
                      @click="addElement('textcurved'), toggleDrawMode(false)"
                    >
                      <v-icon left>mdi-alpha-t-circle-outline</v-icon>
                      <span>Curved Text</span>
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      block
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      tile
                      x-large
                      @click=";(imageDialog = true), toggleDrawMode(false)"
                    >
                      <v-icon left>mdi-image</v-icon>
                      <span>Image</span>
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      block
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      tile
                      x-large
                      @click="toggleDrawMode()"
                    >
                      <v-icon
                        left
                        small
                        class="mb-2"
                        v-if="drawMode == true"
                        :color="config.confirm"
                        >mdi-check</v-icon
                      >
                      <v-icon left small class="mb-2" v-if="drawMode != true" :color="config.alert"
                        >mdi-close</v-icon
                      >
                      <v-icon left>mdi-brush</v-icon>
                      <span>Brush</span>
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mb-2">
                    <h2>Shapes</h2>
                  </v-row>
                  <v-row justify="center">
                    <v-btn-toggle
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      class="mb-2"
                      tile
                      v-model="toggleSettings"
                    >
                      <v-btn :color="config.secondary" @click="addElement('square')">
                        <v-icon>mdi-square</v-icon>
                      </v-btn>
                      <v-btn :color="config.secondary" @click="addElement('circle')">
                        <v-icon>mdi-circle</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      tile
                      block
                      :dark="config.dark_secondary"
                      :color="config.secondary"
                      x-large
                      @click="getPublicBackgrounds()"
                    >
                      <v-icon left>mdi-image</v-icon>
                      <span>Backgrounds</span>
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mb-3">
                    <v-btn
                      block
                      :color="config.secondary"
                      :dark="config.dark_secondary"
                      tile
                      x-large
                      @click="templateDialog = true"
                    >
                      <v-icon left>mdi-apps</v-icon>
                      <span>Templates</span>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <div class="mt-5 mb-5">
                <h4 :class="{ 'size-warning': chipSize >= chipSizeMax }">
                  Chip Capacity: % {{ Math.round((chipSize / chipSizeMax) * 100) }}
                </h4>
                <v-progress-linear
                  :color="config.alert"
                  height="8"
                  :value="(chipSize / chipSizeMax) * 100"
                  striped
                >
                </v-progress-linear>
              </div>
              <v-row justify="center" class="mt-5">
                <v-btn
                  :color="config.alert"
                  dark
                  tile
                  width="160"
                  @click=";(warningType = 'clear'), (warningDialog = true)"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  <span>Clear Chip</span>
                </v-btn>
              </v-row>
            </v-container>
          </v-card>
        </div>
        <div class="canvas-container">
          <div id="canvas-overlay">
            <img
              v-if="bleedGuide"
              id="canvas-overlay-image"
              :src="`${config.backendURL}/public/circle_highres.png`"
              alt=""
            />
            <v-overlay
              v-if="canvasLoading"
              absolute
              opacity="0.4"
              style="height:650px;width:650px;border-radius:50%;"
            >
              <v-progress-circular indeterminate size="128" absolute v-bind:color="config.primary">
              </v-progress-circular>
            </v-overlay>
          </div>
          <canvas id="c" class="canvas-element" width="650" height="650"> </canvas>
          <!-- Main Canvas -->
          <v-container class="toolbar-nav">
            <div class="toolbar-item">
              <v-btn-toggle
                v-if="activeSettings != 'canvas' && !drawMode"
                :color="config.secondary"
                :dark="config.dark_secondary"
                :max="-1"
              >
                <v-btn @click="deleteElement()">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn @click="duplicate()">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn @click="pushBack()">
                  <v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
                <v-btn @click="pushFront()">
                  <v-icon>mdi-arrow-up-bold</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
            <div
              class="toolbar-item"
              v-if="activeSettings == 'textbox' || (activeSettings == 'textcurved' && !drawMode)"
            >
              <v-btn-toggle v-model="fontFeatures" color="grey lighten-2" dark multiple>
                <v-btn>
                  <v-icon>mdi-format-bold</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-format-italic</v-icon>
                </v-btn>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-underline</v-icon>
                </v-btn>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-overline</v-icon>
                </v-btn>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-strikethrough</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
            <div
              class="toolbar-item"
              v-if="activeSettings == 'textbox' || (activeSettings == 'textcurved' && !drawMode)"
            >
              <v-btn-toggle v-model="fontSettings.alignment" color="grey lighten-2" dark mandatory>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-align-left</v-icon>
                </v-btn>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-align-center</v-icon>
                </v-btn>
                <v-btn :disabled="activeSettings == 'textcurved'">
                  <v-icon>mdi-format-align-right</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-container>
        </div>
      </div>
      <div class="settings-element">
        <v-card
          class="settings-card"
          elevation="4"
          :dark="config.dark_background"
          :color="config.background_dark_slight"
        >
          <v-toolbar v-bind:color="config.primary" dark flat>
            <!-- Toolbar -->
            <v-toolbar-title>
              <v-icon>mdi-cog</v-icon>
              <span v-if="drawMode" class="ml-2">Brush</span>
              <span v-if="activeSettings == 'textcurved' && drawMode == false" class="ml-2"
                >Curved Text</span
              >
              <span v-if="activeSettings == 'image' && drawMode == false" class="ml-2">Image</span>
              <span v-if="activeSettings == 'misc' && drawMode == false" class="ml-2">Drawing</span>
              <span v-if="activeSettings == 'group' && drawMode == false" class="ml-2">Group</span>
              <span v-if="activeSettings == 'textbox' && drawMode == false" class="ml-2"
                >Textbox</span
              >
              <span v-if="activeSettings == 'element' && drawMode == false" class="ml-2"
                >Element</span
              >
              <span v-if="activeSettings == 'canvas' && drawMode == false" class="ml-2"
                >General</span
              >
              <span> Settings</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :loading="printLoading" class="mr-5" outlined @click="enablePrepPrint()">
              <span>Print</span>
              <v-icon right>mdi-printer</v-icon>
            </v-btn>
            <v-btn outlined @click="createDialog = true">
              <span>Save Chip</span>
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="div-container">
            <!-- Color Picker Settings -->
            <v-row>
              <v-col cols="12" sm="6">
                <v-color-picker
                  :swatches="swatches"
                  show-swatches
                  class="mt-3"
                  v-model="color"
                  flat
                ></v-color-picker>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn
                  class="mb-3"
                  tile
                  block
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click="savedColor = color"
                  v-if="!drawMode && activeSettings != 'misc'"
                >
                  <v-icon left :color="savedColor">mdi-eyedropper-plus</v-icon>
                  <span>
                    <h4>Copy Current Color</h4>
                  </span>
                </v-btn>
                <v-btn
                  class="mb-3"
                  tile
                  block
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click="color = savedColor"
                  v-if="!drawMode && activeSettings != 'misc'"
                >
                  <v-icon left :color="savedColor">mdi-format-color-fill</v-icon>
                  <span>
                    <h4>Paste Color</h4>
                  </span>
                </v-btn>
                <div class="mb-3" style="display: flex; justify-content: space-between;">
                  <v-btn
                    style="flex-grow: 1; margin-right:6px;"
                    tile
                    large
                    :color="config.secondary"
                    :dark="config.dark_secondary"
                    @click="changeBackgroundColor(color)"
                  >
                    <v-icon left :color="this.color">mdi-palette</v-icon>
                    Color Background
                  </v-btn>
                  <v-btn
                    tile
                    large
                    :color="config.secondary"
                    :dark="config.dark_secondary"
                    @click="changeBackgroundColor(color, 'clear')"
                  >
                    <v-icon color="white">mdi-cancel</v-icon>
                  </v-btn>
                </div>
                <div
                  v-if="!drawMode && activeSettings == 'textcurved'"
                  class="mb-3"
                  style="display: flex; justify-content: space-between;"
                >
                  <v-text-field
                    v-if="activeSettings == 'textcurved'"
                    v-model="fontSettings.text"
                    label="Display Text"
                    hint="What should this textbox say?"
                  ></v-text-field>
                </div>
                <v-btn
                  class="mb-3"
                  tile
                  block
                  large
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click="resetBackground()"
                  v-if="!drawMode && activeSettings == 'canvas'"
                >
                  <v-icon left>mdi-close</v-icon>
                  <span>
                    <h4>Clear Background</h4>
                  </span>
                </v-btn>
                <div
                  :style="
                    'background:' +
                      config.background_dark +
                      '; width: 100%; height: 185px; overflow: auto;'
                  "
                  v-if="!drawMode && activeSettings == 'canvas'"
                >
                  <v-card
                    elevation="5"
                    tile
                    :color="saveIndex == index ? config.primary : config.secondary"
                    :key="index"
                    v-for="(save, index) in saveList"
                    class="mx-1 my-1"
                    @click="useSave(save, index)"
                  >
                    <v-card-text>
                      History {{ index + 1 }}
                      <span class="font-weight-bold" v-if="saveIndex == index"
                        >&lt; ACTIVE &gt;</span
                      >
                    </v-card-text>
                  </v-card>
                </div>
                <v-btn
                  class="mb-3"
                  tile
                  block
                  large
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click="fontSettings.shadowColor = color"
                  v-if="activeSettings == 'textbox'"
                >
                  <v-icon left>mdi-palette</v-icon>
                  <span>
                    <h4>Set Shadow Color</h4>
                  </span>
                </v-btn>
                <v-btn
                  class="mb-3"
                  tile
                  block
                  large
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click="fontSettings.outlineColor = color"
                  v-if="activeSettings == 'textbox'"
                >
                  <v-icon left>mdi-content-copy</v-icon>
                  <span>
                    <h4>Set Outline Color</h4>
                  </span>
                </v-btn>
                <v-btn
                  class="mb-3"
                  tile
                  block
                  large
                  :color="config.secondary"
                  :dark="config.dark_secondary"
                  @click=";(brushShadowColor = color), changeBrushShadow()"
                  v-if="drawMode"
                >
                  <v-icon left>mdi-box-shadow</v-icon>
                  <span>
                    <h4>Set Shadow Color</h4>
                  </span>
                </v-btn>
                <div
                  v-if="activeSettings == 'image' && drawMode == false"
                  class="mb-3"
                  style="display: flex; justify-content: space-between; align-items: stretch;"
                >
                  <v-btn
                    style="flex-grow: 1; margin-right:6px;"
                    tile
                    large
                    :color="config.secondary"
                    :dark="config.dark_secondary"
                    @click="changeImageFilter(color, 'multiply')"
                  >
                    <v-icon left :color="this.color">mdi-palette</v-icon>
                    Set Image Color
                  </v-btn>
                  <v-btn
                    tile
                    large
                    :color="config.secondary"
                    :dark="config.dark_secondary"
                    @click="changeImageFilter(color, 'clear')"
                  >
                    <v-icon color="white">mdi-cancel</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            class="div-container"
            v-if="
              activeSettings == 'textbox' || (activeSettings == 'textcurved' && drawMode != true)
            "
          >
            <!-- Textbox Settings -->
            <v-row>
              <v-col cols="12" sm="6">
                <v-menu
                  v-model="fontMenu"
                  :nudge-height="120"
                  offset-y
                  max-height="300"
                  top
                  close-on-content-click
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :spellcheck="false"
                      :dark="config.dark_secondary"
                      :background-color="config.secondary"
                      editable
                      label="Font"
                      v-model="fontSearch"
                      flat
                      filled
                      v-on="on"
                      @click="searchedFontArray = fontArray"
                    >
                      Font Settings
                      <v-icon right>mdi-open-in-app</v-icon>
                    </v-text-field>
                  </template>
                  <v-card tile style="height: 300px;">
                    <v-list>
                      <v-list-item
                        v-for="(font, index) in searchedFontArray"
                        :key="index"
                        @click=";(fontSettings.font = font.value), (fontSearch = font.name)"
                      >
                        <v-list-item-title>
                          <span :style="'font-family:' + font.value + ';'">{{ font.name }} / </span>
                          <span :style="'font-family:' + font.value + ';font-weight:bold;'">
                            {{ font.name }}</span
                          >
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="searchedFontArray.length === 0">
                        <v-list-item-title>No results</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>

                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="fontSettings.shadowSize"
                  min="0"
                  max="10"
                  label="Shadow Height"
                ></v-slider>
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="fontSettings.outlineWidth"
                  v-if="activeSettings != 'textcurved'"
                  min="0"
                  max="4"
                  label="Outline Width"
                ></v-slider>
                <v-list-item
                  v-if="activeSettings == 'textcurved'"
                  :dark="config.dark_secondary"
                  class="mb-3"
                  @click="fontSettings.flipped = !fontSettings.flipped"
                >
                  <v-checkbox :readonly="true" :input-value="fontSettings.flipped" label="Flipped">
                  </v-checkbox>
                  <v-list-item-action class="ml-auto">
                    <v-icon>mdi-circle-outline</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="6">
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="fontSettings.curvedFontSize"
                  v-if="activeSettings == 'textcurved'"
                  min="40"
                  max="120"
                  label="Font Size"
                ></v-slider>
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="fontSettings.kerning"
                  v-if="activeSettings == 'textcurved'"
                  min="0"
                  max="20"
                  label="Kerning"
                ></v-slider>
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="fontSettings.diameter"
                  v-if="activeSettings == 'textcurved'"
                  min="300"
                  max="800"
                  label="Diameter"
                ></v-slider>
              </v-col>
            </v-row>
          </div>
          <div class="div-container" v-if="drawMode == true">
            <!-- Brush Settings -->
            <v-row>
              <v-col cols="12" sm="6">
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="brushWidth"
                  min="1"
                  max="100"
                  label="Brush Width"
                  @click="changeBrushWidth()"
                ></v-slider>
                <v-slider
                  :track-color="config.secondary"
                  :thumb-color="config.primary"
                  :color="config.primary"
                  v-model="brushShadow"
                  min="0"
                  max="100"
                  label="Brush Shadow Width"
                  @click="changeBrushShadow()"
                ></v-slider>
              </v-col>
              <!-- Disabled for now because of insane object size when using other brushes -->
              <!-- <v-col cols="12" sm="6">
                <v-overflow-btn
                  :items="['Pencil', 'Spray', 'Bubbles']"
                  label="Brush Mode"
                  v-model="brushMode"
                  outlined
                ></v-overflow-btn>
              </v-col> -->
            </v-row>
          </div>
          <div class="div-container" v-if="activeSettings == 'canvas' && drawMode == false">
            <!-- Canvas Settings -->
            <v-row>
              <v-col cols="12" sm="6">
                <v-list-item :dark="config.dark_secondary" class="mb-3" @click="addOutline()">
                  <v-checkbox :readonly="true" :input-value="bleedGuide" label="Bleed Outline">
                  </v-checkbox>
                  <v-list-item-action class="ml-auto">
                    <v-icon>mdi-circle-outline</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="overlay-box">
                  <img
                    crossorigin="anonymous"
                    :src="chipOverlays[activeOverlay]"
                    class="overlay-chip"
                  />
                  <img crossorigin="anonymous" :src="chipIcon" class="overlay-image" />
                </div>
                <v-row justify="center" class="text-center">
                  <v-col cols="12" sm="2">
                    <v-btn @click="switchChip('sub')" icon>
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-btn :color="config.secondary" @click="switchChip('reset')" elevation="0">
                      Preview {{ activeOverlay + 1 }} / {{ chipOverlays.length }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-btn @click="switchChip('add')" icon>
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
    </div>
    <div>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        :key="0"
      >
        <!-- Print Page -->
        <f-s-modal :canvas_data="dialogCanvas">
          <template v-slot:actions>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Print and Adjust</v-toolbar-title>
          </template>
        </f-s-modal>
      </v-dialog>
      <v-dialog v-model="createDialog" width="650">
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h3>
                Publish your custom chip
              </h3>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" icon large @click="createDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-overlay v-if="publishLoading" opacity="0.3">
              <v-progress-circular indeterminate size="128" absolute v-bind:color="config.primary">
              </v-progress-circular>
            </v-overlay>
          </template>
          <template v-slot:title>
            <div style="width:100%">
              <v-alert
                class="text-break"
                width="100%"
                border="bottom"
                type="error"
                :color="config.alert"
                elevation="4"
                :key="index"
                v-for="(error, index) in publishError"
              >
                <p>
                  {{ error.error }}
                </p>
              </v-alert>
            </div>
          </template>
          <template v-slot:text>
            <v-text-field v-model="name" label="Name"></v-text-field>
            <v-textarea
              v-model="description"
              label="Description"
              hint="This should describe what your chip looks like"
              auto-grow
              no-resize
            ></v-textarea>
            <v-list-item @click="togglePrivate()" :dark="config.dark_background">
              <v-checkbox
                :readonly="true"
                :input-value="privateCheckbox"
                label="This chip is private"
              >
              </v-checkbox>
              <v-list-item-action class="ml-auto">
                <v-tooltip top :color="config.dull" close-delay="500" dark>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <h3>
                    When this box is checked, only you will be able to view and edit this chip.
                  </h3>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </template>
          <template v-slot:actions>
            <div style="width:100%">
              <v-col cols="12" sm="9" class="ml-auto mr-auto">
                <v-btn elevation="5" block dark @click="createChip()" large :color="config.confirm">
                  <span>Save</span>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="9" class="ml-auto mr-auto" v-if="chips >= maxChips">
                <v-btn
                  elevation="5"
                  block
                  dark
                  @click="deleteChipList()"
                  large
                  :color="config.primary"
                >
                  <span>Delete Chips</span>
                </v-btn>
              </v-col>
            </div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="imageDialog" width="450">
        <!-- Image Dialog -->
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Insert an Image
              </h2>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" icon large @click="imageDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div style="width:100%;">
              <v-alert
                class="text-break"
                width="100%"
                border="bottom"
                type="error"
                :color="config.alert"
                elevation="4"
                v-if="imageErrorMessage"
              >
                <p>
                  {{ imageErrorMessage }}
                </p>
              </v-alert>
            </div>
          </template>
          <template v-slot:text>
            <v-row justify="center" class="mb-5 mt-5">
              <v-btn
                tile
                :loading="imageLoading"
                :dark="config.dark_secondary"
                :color="config.primary"
                large
                @click="getPublicImages()"
              >
                <span>
                  <h3>Browse Images</h3>
                </span>
              </v-btn>
            </v-row>
            <v-row justify="center">
              <v-card-title>Or use your own image...</v-card-title>
            </v-row>
            <div style="height: 270px;">
              <v-row>
                <v-col cols="12" sm="8">
                  <v-file-input
                    accept="image/*"
                    :error="imageError"
                    dense
                    outlined
                    v-model="file"
                    label="Upload A File..."
                  ></v-file-input>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn
                    block
                    tile
                    :loading="imageLoading"
                    :dark="config.dark_secondary"
                    :color="config.secondary"
                    large
                    @click="uploadFile()"
                  >
                    <span>
                      <h3>Upload</h3>
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn
                  tile
                  :loading="imageLoading"
                  :dark="config.dark_secondary"
                  :color="config.secondary"
                  large
                  @click="getUserImages()"
                >
                  <span>
                    <h3>Browse Your Images</h3>
                  </span>
                </v-btn>
              </v-row>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="userImageBrowseDialog" width="1000">
        <!-- User's Image Browse Dialog -->
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Your Image Library
              </h2>
              <v-spacer></v-spacer>
              <v-btn
                class="mr-1"
                icon
                large
                @click=";(imageDialog = true), (userImageBrowseDialog = false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div></div>
          </template>
          <template v-slot:text>
            <div class="image-container">
              <v-card
                :color="config.background"
                tile
                v-bind:key="index"
                v-for="(img, index) in publicImages"
                elevation="0"
                class="image-item"
                max-width="200"
                max-height="200"
                @mouseover="shownImageIndex = index"
                @mouseout="shownImageIndex = null"
              >
                <v-overlay v-show="index == shownImageIndex" :absolute="true" opacity="0.2">
                  <v-row justify="center" class="mb-5">
                    <v-btn
                      style="opacity: 0.8;"
                      small
                      dense
                      elevation="0"
                      :loading="imageLoading"
                      :color="config.confirm"
                      large
                      @click="addImage(img)"
                    >
                      Insert
                    </v-btn>
                  </v-row>
                  <v-row justify="center" class="mt-5">
                    <v-btn
                      style="opacity: 0.8;"
                      small
                      dense
                      elevation="0"
                      :loading="imageLoading"
                      :color="config.alert"
                      large
                      @click="deleteUserImage(img)"
                    >
                      Delete
                    </v-btn>
                  </v-row>
                </v-overlay>
                <v-img
                  contain
                  lazy-src=""
                  :src="img"
                  crossorigin="anonymous"
                  width="200"
                  height="200"
                >
                </v-img>
              </v-card>
              <v-card :color="config.secondary" flat v-if="publicImages.length == 0">
                <v-card-title>Sorry, we could not find anything. Try again later.</v-card-title>
              </v-card>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="imageBrowseDialog" width="1000">
        <!-- Image Browse Dialog -->
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Click any image
              </h2>
              <v-spacer></v-spacer>
              <v-btn
                class="mr-1"
                icon
                large
                @click=";(imageDialog = true), (imageBrowseDialog = false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div></div>
          </template>
          <template v-slot:text>
            <div class="image-container">
              <v-card
                :color="config.background"
                tile
                v-bind:key="index"
                v-for="(img, index) in publicImages"
                elevation="0"
                class="image-item"
                max-width="150"
                max-height="150"
                @click="addImage(img)"
              >
                <v-img
                  contain
                  lazy-src=""
                  :src="img"
                  crossorigin="anonymous"
                  width="150"
                  height="150"
                >
                </v-img>
              </v-card>
              <v-card flat v-if="publicImages.length == 0">
                <v-card-title>Sorry, we could not find anything. Try again later.</v-card-title>
              </v-card>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="backgroundBrowseDialog" width="1200">
        <!-- Background Browse Dialog -->
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Click any background
              </h2>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" icon large @click="backgroundBrowseDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div></div>
          </template>
          <template v-slot:text>
            <div class="image-container">
              <v-card
                tile
                v-bind:key="index"
                v-for="(img, index) in publicImages"
                elevation="0"
                class="image-item"
                max-width="150"
                max-height="150"
                @click="addBackgroundImage(img)"
              >
                <v-img
                  contain
                  lazy-src=""
                  :src="img"
                  crossorigin="anonymous"
                  width="150"
                  height="150"
                  class="grey--text align-end"
                >
                </v-img>
              </v-card>
              <v-card flat v-if="publicImages.length == 0">
                <v-card-title>Sorry, we could not find anything. Try again later.</v-card-title>
              </v-card>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="templateDialog" width="80%">
        <!-- Template Dialog -->
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Click a template to use it
              </h2>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" icon large @click="templateDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div></div>
          </template>
          <template v-slot:text>
            <div class="image-container">
              <v-card
                tile
                :key="index"
                v-for="(item, index) in templateList"
                elevation="0"
                class="image-item"
                max-width="240"
                max-height="240"
                @click="
                  ;(currentTemplate = item),
                    (warningType = 'template'),
                    (templateDialog = false),
                    (warningDialog = true)
                "
                style="border-radius: 50%;"
              >
                <v-img
                  contain
                  lazy-src=""
                  :src="item.image"
                  crossorigin="anonymous"
                  width="240"
                  height="240"
                  class="grey--text align-end"
                  style="border-radius: 50%;"
                >
                </v-img>
              </v-card>
              <v-card flat v-if="templateList.length == 0">
                <v-card-title>Sorry, we could not find anything. Try again later.</v-card-title>
              </v-card>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="warningDialog" width="500px">
        <modal>
          <template v-slot:title>
            <v-card-title class="text-break">
              Are you sure you want to do this?
            </v-card-title>
            <v-card-text class="text-break">
              If you continue, your current chip will be erased.
            </v-card-text>
          </template>
          <template v-slot:actions>
            <v-col cols="12" sm="6">
              <v-btn
                v-if="warningType == 'clear'"
                elevation="0"
                @click="resetCanvas(), (warningDialog = false)"
                :color="config.primary"
                block
              >
                Clear chip
              </v-btn>
              <v-btn
                v-if="warningType == 'template'"
                elevation="0"
                @click="useTemplate(currentTemplate), (warningDialog = false)"
                :color="config.primary"
                block
              >
                Use template
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                v-if="warningType == 'template'"
                elevation="0"
                @click=";(warningDialog = !warningDialog), (templateDialog = true)"
                :color="config.confirm"
                block
              >
                Go back
              </v-btn>
              <v-btn
                v-if="warningType == 'clear'"
                elevation="0"
                @click="warningDialog = !warningDialog"
                :color="config.confirm"
                block
              >
                Go back
              </v-btn>
            </v-col>
          </template>
        </modal>
      </v-dialog>
      <v-dialog persistent v-model="overrideDialog" width="500px">
        <modal>
          <template v-slot:title>
            <v-card-title class="text-break">
              You already have a chip with this name!
            </v-card-title>
            <v-card-text class="text-break">
              Would you like to override your previous chip?
            </v-card-text>
          </template>
          <template v-slot:actions>
            <v-col cols="12" sm="6">
              <v-btn
                :loading="canvasLoading"
                elevation="0"
                @click="overrideChip(chipOverride)"
                :color="config.primary"
                block
              >
                Override Chip
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                :loading="canvasLoading"
                elevation="0"
                @click="overrideDialog = false"
                :color="config.confirm"
                block
              >
                Cancel
              </v-btn>
            </v-col>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="saveDialog" width="80%">
        <modal>
          <template v-slot:toolbar>
            <v-toolbar v-bind:color="config.primary" dark flat>
              <h2>
                Click one of your chips to delete it
              </h2>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" icon large @click=";(saveDialog = false), (createDialog = true)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:title>
            <div></div>
          </template>
          <template v-slot:text>
            <div class="image-container">
              <v-card
                tile
                v-bind:key="index"
                v-for="(item, index) in userChipList"
                elevation="0"
                class="image-item"
                max-width="200"
                max-height="200"
                style="border-radius: 50%;"
              >
                <v-overlay
                  style="border-radius:50%;"
                  opacity="0.8"
                  absolute
                  v-if="loadingList.includes(item._id)"
                >
                  <v-progress-circular
                    indeterminate
                    size="128"
                    absolute
                    v-bind:color="config.primary"
                  >
                  </v-progress-circular>
                </v-overlay>
                <v-img
                  contain
                  lazy-src=""
                  :src="item.image"
                  crossorigin="anonymous"
                  width="200"
                  height="200"
                  class="grey--text align-end"
                  style="border-radius: 50%; cursor: pointer;"
                  @click="openDeleteDialog(item)"
                >
                </v-img>
              </v-card>
              <v-card :color="config.secondary" flat v-if="userChipList.length == 0">
                <v-card-title>We could not find anything.</v-card-title>
              </v-card>
            </div>
          </template>
          <template v-slot:actions>
            <div></div>
          </template>
        </modal>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="500px">
        <modal>
          <template v-slot:title>
            <v-card-title class="text-break">
              Are you sure you want to delete this chip?
            </v-card-title>
          </template>
          <template v-slot:actions>
            <v-col cols="12" sm="6">
              <v-btn
                :loading="canvasLoading"
                elevation="0"
                @click="deleteChip(deleteSelected)"
                :color="config.primary"
                block
              >
                Delete
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn
                :loading="canvasLoading"
                elevation="0"
                @click=";(deleteDialog = false), (saveDialog = false)"
                :color="config.confirm"
                block
              >
                Cancel
              </v-btn>
            </v-col>
          </template>
        </modal>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'
import { mapGetters } from 'vuex'
import config from '@/config/config'
import FabricPlugin from '@/services/FabricPlugin'
import { fabric } from 'fabric'
import FabricService from '@/services/FabricService'
import UserService from '@/services/UserService'
import ObjectService from '@/services/ObjectService'
import ItemService from '@/services/ItemService'
import AuthService from '@/services/AuthService'
import FSModal from '@/components/FSModal.vue'

FabricPlugin(fabric) // Init. Curved text plugin

export default {
  data() {
    return {
      fontArray: [
        { name: 'Arial', value: `Arial` },
        { name: 'Calibri', value: `Calibri` },
        { name: 'Times New Roman', value: `Times New Roman` },
        { name: 'Impact', value: `Impact` },
        { name: 'Verdana', value: `Verdana` },
        { name: 'Courier New', value: `Courier New` },
        { name: 'Franklin Gothic', value: `Franklin Gothic Medium` },
        { name: 'Comic Sans', value: `Comic Sans MS, Comic Sans` },
      ],
      searchedFontArray: [],
      fontMenu: false,
      fontSearch: '',

      curvedTextRendering: false,

      deleteDialog: false,
      deleteSelected: null,
      chipWarning: false,
      loadingList: [],
      maxChips: null,
      chips: null,

      chipOverride: null,
      overrideDialog: false,
      canvasLoading: false,
      userChipList: [],

      activeOverlay: 0,
      chipOverlays: [
        require('@/assets/blackchip.svg'),
        require('@/assets/redchip.svg'),
        require('@/assets/greenchip.svg'),
        require('@/assets/bluechip.svg'),
        require('@/assets/whitechip.svg'),
      ],
      chipIcon: '',

      sounds: {
        click: new Audio(require('@/assets/sounds/click.mp3')),
        trash: new Audio(require('@/assets/sounds/trash.mp3')),
        error: new Audio(require('@/assets/sounds/error.wav')),
        click2: new Audio(require('@/assets/sounds/click2.wav')),
        click3: new Audio(require('@/assets/sounds/click3.wav')),
      },
      editingElement: null,

      currentlyUndoing: false,
      maxSaves: 10,
      saveIndex: -1,
      saveList: [],

      currentTemplate: null,
      warningDialog: false,
      warningType: '',

      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#0000FF', '#0000AA', '#000055'],
        ['#FFFFFF', '#818181', '#000000'],
      ],
      chromeWarning: false,
      enableSizeWarning: true,
      sizeWarningDialog: false,
      saveDialog: false,
      shownImageIndex: null,
      userImageBrowseDialog: false,
      imageErrorMessage: null,
      file: null,
      printLoading: false,

      backgroundBrowseDialog: false,
      templateList: [],
      templateDialog: false,
      imageBrowseDialog: false,
      imageDialog: false,
      publicImages: [],
      imageList: [],
      backgroundList: [],

      toggleSettings: null,
      savedColor: '#8F8F8F',
      chipSize: 0,
      chipSizeMax: 81920,
      backgroundImageSrc: `${config.backendURL}/public/assets/example.png`,
      imageLoading: false,
      imageError: null,
      imageSettings: {
        src: `${config.backendURL}/public/assets/example.png`,
        defaultSrc: `${config.backendURL}/public/assets/example.png`,
      },
      fontFeatures: [],
      fontSettings: {
        alignment: 0,
        bold: false,
        underline: false,
        strikethrough: false,
        overline: false,
        italic: false,
        outlineColor: '#000000',
        outlineWidth: 0,
        shadowColor: '#000000',
        shadowSize: 0,
        fontSize: 72,
        font: 'Arial',
        kerning: 0,
        diameter: 544,
        text: 'Curved Textbox',
        curvedFontSize: 82,
        flipped: false,
      },
      brushMode: 'Pencil',
      brushShadowColor: '#000000',
      brushWidth: 10,
      brushShadow: 0,
      publishError: null,
      publishLoading: false,
      createDialog: false,
      activeSettings: 'canvas',
      drawMode: false,
      dialog: false,
      canvas: {},
      dialogCanvas: '',
      name: 'A Very Cool Chip',
      description: 'This is a very awesome chip!',
      export: {},
      type: 'hex',
      hexa: '#FF0000',
      hex: '#FF0000',
      privateCheckbox: true, // Private chip checkbox
      config,
      overlay: `${config.backendURL}/public/circle_highres_blank.png`,
      bleedGuide: true,
      viewportSize: [
        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
      ],
    }
  },
  methods: {
    setupFonts() {
      UserService.getFonts().then((response) => {
        const fileArray = response.data.files
        fileArray.forEach((file) => {
          const array = file.split('-')
          this.fontArray.push({
            name: array[0],
            value: array[0],
          })
        })
      })
    },
    async openDeleteDialog(item) {
      this.deleteSelected = item
      this.deleteDialog = true
    },
    async playSound(sound) {
      sound.currentTime = 0
      sound.play()
    },
    async switchChip(action) {
      switch (action) {
        case 'sub':
          if (this.activeOverlay > 0) this.activeOverlay = this.activeOverlay - 1
          break
        case 'add':
          if (this.activeOverlay < this.chipOverlays.length - 1)
            this.activeOverlay = this.activeOverlay + 1
          break
        case 'reset':
          if (this.activeOverlay != 0) this.activeOverlay = 0
          this.showIcon()
          break
      }
    },
    async showIcon() {
      setTimeout(() => {
        this.chipIcon = this.canvas.toDataURL('image/png')
      }, 50)
    },
    async initiateSave(timeout) {
      // Safely initiate a save. Works when multiple are called at once.
      if (this.currentlyUndoing == false) {
        this.currentlyUndoing = true
        setTimeout(() => {
          this.saveUndo()
        }, timeout)
      }
    },
    async useSave(save, index) {
      // This function handles manually loading a save from the saveUndo list
      if (this.currentlyUndoing == false) {
        this.saveIndex = index
        let self = this
        self.currentlyUndoing = true
        self.canvas.loadFromJSON(save, function() {
          self.canvas.renderAll()
          self.currentlyUndoing = false
          self.showIcon()
        })
      }
    },
    async redo() {
      if (this.currentlyUndoing == false) {
        if (this.saveIndex > 0) {
          this.saveIndex = this.saveIndex - 1
          let self = this
          self.currentlyUndoing = true
          self.canvas.loadFromJSON(this.saveList[this.saveIndex], function() {
            self.canvas.renderAll()
            self.currentlyUndoing = false
          })
        }
      }
    },
    async undo() {
      // This function moves the saved Index up and loads the corresponding canvas save
      if (this.currentlyUndoing == false) {
        // Detect if the system is currently processing an undo or save-undo request
        let self = this
        if (this.saveIndex != -1 && this.saveIndex < this.saveList.length - 1) {
          if (this.saveIndex < this.maxSaves) {
            self.currentlyUndoing = true
            this.saveIndex = this.saveIndex + 1
            self.canvas.loadFromJSON(this.saveList[this.saveIndex], function() {
              self.canvas.renderAll()
              self.currentlyUndoing = false
              self.showIcon()
            })
          } else {
            this.$store.dispatch('setAlert', {
              notification: 'You have reached the maximum number of undo requests!',
            })
          }
        }
      }
    },
    async saveUndo() {
      // This function saves the current canvas to the saved - list
      this.currentlyUndoing = true
      const savedCanvas = await this.canvas.toJSON() // Save the canvas to an object
      if (this.saveList.length < this.maxSaves) {
        await this.saveList.unshift(savedCanvas) // Push the saved canvas to the front of the saved list
        if (this.saveIndex > 0) {
          // This gets fired if the system tries to save after a recent undo-request
          this.saveList = await this.saveList.slice(this.saveIndex)
          this.saveList[0] = savedCanvas
          this.saveIndex = 0
        } else if (this.saveIndex == -1) {
          this.saveIndex = 0
        }
        this.currentlyUndoing = false
      } else {
        // If the save list reached the maximum
        this.saveList.pop() // Remove the saved entry at the end of the list and push a new saved canvas to the front
        this.saveList.unshift(savedCanvas)
        if (this.saveIndex > 0) {
          // This gets fired if the system tries to save after a recent undo-request
          this.saveList = this.saveList.slice(this.saveIndex)
          this.saveList[0] = savedCanvas
          this.saveIndex = 0
        } else if (this.saveIndex == -1) {
          this.saveIndex = 0
        }
        this.currentlyUndoing = false
      }
    },
    async overrideChip(chip) {
      this.canvasLoading = true
      try {
        this.publishLoading = true
        await this.exportCanvas()
        const sendObj = {
          token: this.getUser.token,
          itemId: chip._id,
          override: this.export,
          private: this.privateCheckbox,
          image: this.chipIcon,
        }
        const response = await ItemService.override(sendObj)
        this.saveDialog = false
        this.createDialog = true
        this.publishLoading = false
        if (response.status == 200) {
          this.$router.push({ name: 'created' })
          this.canvasLoading = false
        }
      } catch (error) {
        this.publishLoading = false
        this.$store.dispatch('setAlert', error)
        this.canvasLoading = false
      }
    },
    async deleteChipList() {
      try {
        this.createDialog = false
        const sendObj = {
          token: this.getUser.token,
        }
        const response = await ItemService.getUserCreated(sendObj)
        const array = await this.addImages(response.data.items)
        this.userChipList = array
        this.saveDialog = true
        return array
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async deleteChip(chip) {
      this.loadingList.push(chip._id)
      this.canvasLoading = true
      try {
        const sendObj = {
          token: this.getUser.token,
          itemId: chip._id,
        }
        const response = await ItemService.delete(sendObj)
        await this.userChipList.forEach((chip) => {
          if (chip._id == response.data._id) {
            this.userChipList.splice(this.userChipList.indexOf(chip), 1)
          }
        })
        this.canvasLoading = false
        this.loadingList.splice(this.loadingList.indexOf(chip._id), 1)
        this.chips--
        this.publishError = null
        this.saveDialog = false
        this.createDialog = true
      } catch (error) {
        this.publishLoading = false
        this.$store.dispatch('setAlert', error)
        this.canvasLoading = false
        this.saveDialog = false
        this.createDialog = true
      }
    },
    async deleteUserImage(src) {
      const srcArray = src.split('/')
      const fileName = srcArray[srcArray.length - 1]
      this.imageLoading = true
      const { token } = this.getUser
      const response = await AuthService.deleteUserImage({ token, fileName })
      this.publicImages = response.data.files
      this.imageLoading = false
    },
    async getUserImages() {
      this.imageLoading = true
      const { token } = this.getUser
      const response = await AuthService.getUserImages({ token })
      this.publicImages = response.data.files
      this.imageLoading = false
      this.userImageBrowseDialog = true
      this.imageDialog = false
    },
    async uploadFile() {
      try {
        if (this.file) {
          const { token } = await this.getUser
          this.imageLoading = true
          var myFormData = new FormData()
          await myFormData.append('user', JSON.stringify({ token }))
          await myFormData.append('file', this.file)
          const response = await UserService.upload(myFormData)
          this.imageLoading = false
          if (response.data.error) {
            console.log(response.data)
            this.imageError = true
            this.imageErrorMessage = response.data.error
            return
          }
          this.imageError = false
          this.imageErrorMessage = null
          this.imageSettings.src = response.data.url
          this.addImage(response.data.url)
          this.imageDialog = false
          this.file = null
        } else {
          this.imageError = true
          this.imageErrorMessage = 'You need to select a file first!'
        }
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    resetCanvas() {
      this.canvas.clear()
      this.canvas.set('backgroundColor', '#424242')
      this.calculateBytes()
    },
    splitHex(hexa) {
      const hex = hexa.slice(0, 7),
        //a = parseInt(hexa.slice(7, 9), 16) / 255;
        a = 1
      return {
        hex,
        a,
      }
    },
    async changeBackgroundFilter(color, mode) {
      let backgroundImage = this.canvas.backgroundImage
      if (mode == 'clear') {
        this.canvas.backgroundImage.filters = []
      } else {
        const { hex, a } = this.splitHex(color)
        const filter = await new fabric.Image.filters.BlendColor({
          color: hex,
          mode: mode,
          alpha: a,
        })
        backgroundImage.filters = [filter]
      }
      backgroundImage.applyFilters()
      this.canvas.renderAll()
      this.showIcon()
    },
    async changeImageFilter(color, mode) {
      const active = await this.canvas.getActiveObject()
      if (active)
        if (active.get('type') == 'image') {
          if (mode == 'clear') {
            active.filters = []
          } else {
            const { hex, a } = this.splitHex(color)
            const filter = await new fabric.Image.filters.BlendColor({
              color: hex,
              mode: mode,
              alpha: a,
            })
            active.filters = [filter]
          }
          active.applyFilters()
          this.canvas.renderAll()
        }
    },
    async getPublicBackgrounds() {
      this.publicImages = this.backgroundList
      this.backgroundBrowseDialog = true
    },
    async addBackgroundImage(img) {
      let self = this
      this.initiateSave(200)
      this.imageLoading = true
      new fabric.Image.fromURL(
        img,
        function(oImg) {
          oImg.set({
            originX: 'center',
            originY: 'center',
            left: 325,
            top: 325,
          })
          self.canvas.setBackgroundImage(oImg)
          self.canvas.renderAll()
          self.showIcon()
        },
        { crossOrigin: 'Anonymous' }
      )
      this.imageError = false
      this.imageLoading = false
      this.backgroundBrowseDialog = false
      return 'success'
    },
    async modifyTextbox() {
      // Detects what font settings are currently active and applies them to the selected object
      const active = await this.canvas.getActiveObject()
      if (active)
        if (active.get('type') == 'textbox') {
          active.set('fontSize', this.fontSettings.fontSize)
          active.set('fontFamily', this.fontSettings.font)
          if (this.fontFeatures.includes(0)) active.set('fontWeight', 'bold')
          else active.set('fontWeight', 'normal')
          if (this.fontFeatures.includes(1)) active.set('fontStyle', 'italic')
          else active.set('fontStyle', 'normal')
          if (this.fontFeatures.includes(2)) active.set('underline', true)
          else active.set('underline', false)
          if (this.fontFeatures.includes(3)) active.set('overline', true)
          else active.set('overline', false)
          if (this.fontFeatures.includes(4)) active.set('linethrough', true)
          else active.set('linethrough', false)
          if (this.fontSettings.alignment == 0) active.set('textAlign', 'left')
          if (this.fontSettings.alignment == 1) active.set('textAlign', 'center')
          if (this.fontSettings.alignment == 2) active.set('textAlign', 'right')
          active.set('strokeWidth', this.fontSettings.outlineWidth)
          active.set('stroke', this.fontSettings.outlineColor)
          active.set(
            'shadow',
            `${this.fontSettings.shadowColor} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize}`
          )
        } else if (active.get('type') == 'textcurved') {
          active.set('fontSize', this.fontSettings.fontSize)
          active.set('fontFamily', this.fontSettings.font)
          if (this.fontFeatures.includes(0)) active.set('fontWeight', 'bold')
          else active.set('fontWeight', 'normal')
          if (this.fontFeatures.includes(1)) active.set('fontStyle', 'italic')
          else active.set('fontStyle', 'normal')
          active.set('kerning', this.fontSettings.kerning)
          active.set('diameter', this.fontSettings.diameter)
          active.set('flipped', this.fontSettings.flipped)
          active.set('fontSize', this.fontSettings.curvedFontSize)
          active.set(
            'shadow',
            `${this.fontSettings.shadowColor} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize}`
          )
          active.updateText(this.fontSettings.text)
        }
      this.canvas.renderAll()
    },
    addImages(array) {
      return array.map(function(item) {
        item.image = config.backendURL + '/public/icons/' + item._id + '.png'
        return item
      })
    },
    async getTemplateList() {
      try {
        const response = await ItemService.getTemplates()
        const array = this.addImages(response.data)
        this.templateList = array
        return array
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    useTemplate(chip) {
      let self = this
      this.name = chip.name
      this.description = chip.description
      this.templateDialog = false
      self.canvasLoading = true
      self.canvas.loadFromJSON(chip.canvas_data, function() {
        self.canvas.renderAll()
        self.initiateSave(100)
        self.showIcon()
        self.canvasLoading = false
      })
    },
    async addImage(src) {
      this.playSound(this.sounds.click)
      let self = this
      this.imageLoading = true
      this.imageError = false
      if (src != '') {
        new fabric.Image.fromURL(
          src,
          function(oImg) {
            let ratio
            if (oImg.width > oImg.height) {
              ratio = 380 / oImg.width
            } else {
              ratio = 380 / oImg.height
            }
            oImg.set({
              originX: 'center',
              originY: 'center',
              left: 325,
              top: 325,
              scaleX: ratio,
              scaleY: ratio,
            })
            self.canvas.add(oImg)
            self.canvas.renderAll()
            self.initiateSave(100)
            self.showIcon()
          },
          { crossOrigin: 'Anonymous' }
        )
        this.imageLoading = false
        this.imageDialog = false
        this.imageDialog = false
        this.imageBrowseDialog = false
        this.userImageBrowseDialog = false
        return 'success'
      }
    },
    async getPublicImages() {
      this.imageLoading = true
      this.publicImages = this.imageList
      this.imageLoading = false
      this.imageBrowseDialog = true
      this.imageDialog = false
    },
    async duplicate() {
      const canvas = this.canvas
      const objects = await canvas.getActiveObjects()
      if (objects.length == 1) {
        const obj = await canvas.getActiveObject()
        obj.clone(function(cloned) {
          cloned.set({ left: cloned.left + 20, top: cloned.top + 20 })
          canvas.add(cloned)
        })
      } else {
        objects.forEach((obj) => {
          obj.clone(function(cloned) {
            cloned.set({ left: cloned.left + 325, top: cloned.top + 325 })
            canvas.add(cloned)
          })
        })
      }
      canvas.renderAll()
    },
    async pushBack() {
      try {
        const active = await this.canvas.getActiveObject()
        if (active) {
          active.sendBackwards()
          this.canvas.renderAll()
        }
        this.showIcon()
      } catch (error) {
        throw error
      }
    },
    async pushFront() {
      try {
        const active = await this.canvas.getActiveObject()
        if (active) {
          active.bringForward()
          this.canvas.renderAll()
        }
        this.showIcon()
      } catch (error) {
        throw error
      }
    },
    async calculateBytes() {
      this.chipSize = ObjectService.roughSizeOfObject(this.canvas.toDatalessJSON())
    },
    async changeBrushMode() {
      if (this.brushMode == 'Pencil') {
        this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas)
        this.canvas.freeDrawingBrush.color = this.color
        this.canvas.freeDrawingBrush.width = this.brushWidth
      } else if (this.brushMode == 'Spray') {
        this.canvas.freeDrawingBrush = new fabric.SprayBrush(this.canvas)
        this.canvas.freeDrawingBrush.color = this.color
        this.canvas.freeDrawingBrush.width = this.brushWidth
      } else if (this.brushMode == 'Bubbles') {
        this.canvas.freeDrawingBrush = new fabric.CircleBrush(this.canvas)
        this.canvas.freeDrawingBrush.color = this.color
        this.canvas.freeDrawingBrush.width = this.brushWidth
      }
    },
    async changeBrushWidth() {
      this.canvas.freeDrawingBrush.width = this.brushWidth
    },
    async changeBrushShadow() {
      this.canvas.freeDrawingBrush.shadow = new fabric.Shadow({
        blur: parseInt(this.brushShadow, 10) || 0,
        offsetX: 0,
        offsetY: 0,
        affectStroke: true,
        color: this.brushShadowColor,
      })
    },
    async deleteElement() {
      const active = await this.canvas.getActiveObjects()
      if (active.length != 0) {
        this.playSound(this.sounds.click3)
        this.canvas.discardActiveObject()
        this.canvas.remove(...active)
        this.initiateSave(300)
      }
    },
    async exportCanvas() {
      this.export = await this.canvas.toJSON()
      this.chipIcon = await this.canvas.toDataURL('image/png')
    },
    async togglePrivate() {
      if (this.privateCheckbox) {
        this.privateCheckbox = false
      } else {
        this.privateCheckbox = true
      }
    },
    async toggleDrawMode(enable) {
      if (enable == true) {
        this.canvas.discardActiveObject().renderAll()
        this.list = false
        this.drawMode = true
        this.canvas.isDrawingMode = true
        this.canvas.freeDrawingBrush.color = this.color
        this.canvas.freeDrawingBrush.width = this.brushWidth
      } else if (enable == false) {
        this.drawMode = false
        this.canvas.isDrawingMode = false
        this.canvas.discardActiveObject().renderAll()
        this.showIcon()
      } else if (this.drawMode) {
        this.drawMode = false
        this.canvas.isDrawingMode = false
        this.canvas.discardActiveObject().renderAll()
        this.showIcon()
      } else {
        this.canvas.discardActiveObject().renderAll()
        this.list = false
        this.drawMode = true
        this.canvas.isDrawingMode = true
        this.canvas.freeDrawingBrush.color = this.color
        this.canvas.freeDrawingBrush.width = this.brushWidth
      }
    },
    async addElement(element) {
      this.playSound(this.sounds.click2)
      let canvas = this.canvas
      const color =
        canvas.backgroundColor == this.color && this.color != '#000000'
          ? '#000000'
          : this.color == canvas.backgroundColor && this.color == '#000000'
          ? '#FFFFFF'
          : this.color
      var fontStyle = 'normal'
      var fontWeight = 'normal'
      var textAlign = 'left'
      switch (element) {
        case 'square':
          canvas.add(
            new fabric.Rect({
              originX: 'center',
              originY: 'center',
              top: 325,
              left: 325,
              fill: color,
              width: 100,
              height: 100,
            })
          )
          break
        case 'circle':
          canvas.add(
            new fabric.Circle({
              originX: 'center',
              originY: 'center',
              top: 325,
              left: 325,
              fill: color,
              radius: 50,
            })
          )
          break
        case 'textbox':
          if (this.fontFeatures.includes(1)) {
            fontStyle = 'italic'
          }
          if (this.fontFeatures.includes(0)) {
            fontWeight = 'bold'
          }
          if (this.fontSettings.alignment == 1) textAlign = 'center'
          if (this.fontSettings.alignment == 2) textAlign = 'right'
          var text = new fabric.Textbox('Textbox', {
            textAlign,
            originX: 'center',
            originY: 'center',
            top: 325,
            left: 325,
            width: 100,
            height: 100,
            fontFamily: this.fontSettings.font,
            fontSize: this.fontSettings.fontSize,
            underline: this.fontFeatures.includes(2),
            overline: this.fontFeatures.includes(3),
            linethrough: this.fontFeatures.includes(4),
            fontStyle,
            fontWeight,
            shadow: `${this.fontSettings.shadowColor} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize}`,
            stroke: this.fontSettings.outlineColor,
            strokeWidth: this.fontSettings.outlineWidth,
            fill: this.color,
          })
          canvas.add(text)
          break
        case 'textcurved':
          if (this.fontFeatures.includes(1)) {
            fontStyle = 'italic'
          }
          if (this.fontFeatures.includes(0)) {
            fontWeight = 'bold'
          }
          var textSample = new fabric.Textcurved(this.fontSettings.text, {
            kerning: this.fontSettings.kerning,
            diameter: this.fontSettings.diameter,
            originX: 'center',
            originY: 'center',
            top: 180,
            left: 325,
            fontFamily: this.fontSettings.font,
            fontSize: this.fontSettings.fontSize,
            shadow: `${this.fontSettings.shadowColor} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize} ${this.fontSettings.shadowSize}`,
            fill: this.color,
            hasRotatingPoint: true,
            flipped: this.fontSettings.flipped,
          })
          canvas.add(textSample)
          canvas.renderAll()
          break
        case 'image': // case image
          this.imageLoading = true
          this.imageError = false
          if (this.imageSettings.src != '') {
            new fabric.Image.fromURL(
              this.imageSettings.src,
              function(oImg) {
                oImg.set({
                  originX: 'center',
                  originY: 'center',
                  left: 325,
                  top: 325,
                })
                canvas.add(oImg)
                canvas.renderAll()
              },
              { crossOrigin: 'Anonymous' }
            )
            this.imageLoading = false
            this.imageDialog = false
          }
          break
      }
      this.initiateSave(100)
      this.showIcon()
    },
    async enablePrepPrint() {
      this.printLoading = true
      this.dialogCanvas = await this.canvas.toDataURL('image/png')
      this.dialog = true
      this.canvas.renderAll()
      this.printLoading = false
    },
    addOutline(overlay) {
      if (overlay == true) {
        this.bleedGuide = true
      } else if (overlay == false) {
        this.bleedGuide = false
      } else {
        if (this.bleedGuide == true) {
          this.bleedGuide = false
        } else if (this.bleedGuide == false) {
          this.bleedGuide = true
        }
      }
    },
    async createChip() {
      try {
        this.publishLoading = true
        await this.exportCanvas()
        const sendObj = {
          token: this.getUser.token,
          item: {
            name: this.name,
            description: this.description,
            canvas_data: this.export,
            private: this.privateCheckbox,
            image: this.chipIcon,
          },
        }
        const bytes = await ObjectService.roughSizeOfObject(this.export)
        if (bytes >= this.chipSizeMax) {
          this.publishLoading = false
          this.createDialog = false
          this.$store.dispatch(
            'setAlert',
            'This chip is over the maximum size! Please delete a few objects before uploading!'
          )
        } else {
          UserService.createChip(sendObj)
            .then(() => {
              this.publishLoading = false
              this.$router.push({ name: 'created' })
            })
            .catch((error) => {
              this.publishLoading = false
              if (error.response.data.errors) {
                this.publishError = error.response.data.errors
                error.response.data.errors.forEach((element) => {
                  if (element.override) {
                    this.chipOverride = element.item
                    this.overrideDialog = true
                  }
                })
              } else {
                this.createDialog = false
                this.$store.dispatch('setAlert', 'An unexpected error has occured')
              }
            })
        }
      } catch (error) {
        this.publishLoading = false
        this.publishError = error.response.data[0].error
      }
    },
    async downloadFile(name) {
      // Unused right now
      const uri = await this.canvas.toDataURL('image/png')
      let link = document.createElement('a')
      link.download = name
      link.href = uri
      await document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.canvas.renderAll()
    },
    checkLogin() {
      if (!this.loggedIn) {
        this.$router.push({ name: 'login' })
      }
    },
    async changeColor(color) {
      try {
        if (this.canvas.isRendering == 0) {
          if (this.drawMode) {
            this.canvas.freeDrawingBrush.color = color
          } else {
            const active = await this.canvas.getActiveObject()
            if (active) {
              active.set('fill', color)
              this.canvas.requestRenderAll()
            }
          }
        }
      } catch (error) {
        this.$store.dispatch('setAlert', error)
      }
    },
    async changeBackgroundColor(color, clear) {
      this.initiateSave(200)
      if (this.canvas.backgroundImage && clear != 'clear') {
        // If there is a background image set and clear is NOT set
        this.changeBackgroundFilter(color, 'multiply')
      } else if (this.canvas.backgroundImage && clear == 'clear') {
        // If there is a background image set and clear IS set
        this.changeBackgroundFilter(color, 'clear')
      } else if (!this.canvas.backgroundImage && clear == 'clear') {
        // if there is no background image and clear IS set
        this.canvas.setBackgroundColor('#424242').renderAll()
      } else {
        // If there is no background image and clear is NOT set
        this.canvas.setBackgroundColor(color).renderAll()
      }
      this.showIcon()
    },
    async resetBackground() {
      this.canvas
        .setBackgroundImage()
        .setBackgroundColor('#424242')
        .renderAll()
      this.initiateSave(200)
      this.showIcon()
    },
    async updateVariables(e) {
      const object = e.selected[0]
      var fontList = new Array()
      let f = this.fontSettings
      if (e.selected.length == 1)
        switch (object.get('type')) {
          case 'textcurved':
            if (object.fontWeight == 'bold') fontList.push(0)
            if (object.fontStyle == 'italic') fontList.push(1)
            this.fontFeatures = fontList
            f.alignment = object.textAlign == 'right' ? 2 : object.textAlign == 'center' ? 1 : 0
            f.bold = object.fontWeight == 'bold' ? true : false
            f.italic = object.fontStyle == 'italic' ? true : false
            f.shadowColor = object.shadow.color
            f.shadowSize = object.shadow.offsetX
            f.fontSize = object.fontSize
            f.font = object.fontFamily
            f.kerning = object.kerning
            f.diameter = object.diameter
            f.text = object.text
            f.curvedFontSize = object.fontSize
            f.flipped = object.flipped
            this.color = object.fill
            this.fontSearch = object.fontFamily
            this.activeSettings = 'textcurved'
            break
          case 'textbox':
            if (object.fontWeight == 'bold') fontList.push(0)
            if (object.fontStyle == 'italic') fontList.push(1)
            if (object.underline) fontList.push(2)
            if (object.overline) fontList.push(3)
            if (object.linethrough) fontList.push(4)
            this.fontFeatures = fontList
            ;(f.alignment = object.textAlign == 'right' ? 2 : object.textAlign == 'center' ? 1 : 0),
              (f.bold = object.fontWeight == 'bold' ? true : false),
              (f.underline = object.underline),
              (f.strikethrough = object.linethrough),
              (f.overline = object.overline),
              (f.italic = object.fontStyle == 'italic' ? true : false),
              (f.outlineColor = object.stroke),
              (f.outlineWidth = object.strokeWidth),
              (f.shadowColor = object.shadow.color),
              (f.shadowSize = object.shadow.offsetX),
              (f.fontSize = object.fontSize),
              (f.font = object.fontFamily),
              (this.color = object.fill)
            this.fontSearch = object.fontFamily
            this.activeSettings = 'textbox'
            break
          case 'rect':
            this.color = object.fill
            this.activeSettings = 'element'
            break
          case 'circle':
            this.color = object.fill
            this.activeSettings = 'element'
            break
          case 'activeSelection':
            this.activeSettings = 'group'
            break
          case 'path':
            this.activeSettings = 'misc'
            break
          case 'image':
            this.activeSettings = 'image'
            break
        }
      else this.activeSettings = 'group'
    },
    transformCanvas(canvas) {
      let JSONCanvas = JSON.stringify(canvas)
      JSONCanvas = JSONCanvas.replaceAll(/https:\/\/landsoflegends.com:8081/g, config.backendURL)
      JSONCanvas = JSONCanvas.replaceAll(
        /https:\/\/server.missionxartisan.com:8081/g,
        config.backendURL
      )

      const newCanvas = JSON.parse(JSONCanvas)
      return newCanvas
    },
    startUp() {
      let self = this // Initiate self variable for closed functions
      this.bleedGuide = true // Set the bleed guide variable to true
      let clipboard = new Array()
      let undoFunction = this.undo
      let redoFunction = this.redo
      let mouseX = null
      let mouseY = null

      this.canvasLoading = true // set canvas to currently loading

      this.canvas = new fabric.Canvas('c', {
        // Initiate canvas
        backgroundColor: '#424242',
        selectionLineWidth: 2,
        preserveObjectStacking: true,
      })

      self.canvas.setOverlayImage(
        self.overlay,
        function(img, error) {
          if (error) {
            console.log(error)
          }
          self.canvas.requestRenderAll()
          self.canvasLoading = false // set canvas to NOT currently loading
        },
        {
          width: self.canvas.width,
          height: self.canvas.height,
          originX: 'left',
          originY: 'top',
          crossOrigin: 'anonymous',
        }
      )

      // Check if the user is editing a chip that has been imported from another source
      if (this.itemInfo) {
        // If so, load that chip into the canvas
        this.name = this.itemInfo.name
        this.description = this.itemInfo.description
        this.privateCheckbox = this.itemInfo.private
        this.templateDialog = false

        const canvasToLoad = this.transformCanvas(this.itemInfo.canvas_data)

        self.canvas.loadFromJSON(canvasToLoad, function() {
          self.canvas.renderAll()
          self.showIcon()
        })
      } else {
        self.showIcon() // Make an icon for the bottom right
      }

      // Get Images from server
      FabricService.getBackgrounds().then((response) => {
        this.backgroundList = response.data.files.map(
          (file) => `${config.backendURL}/public/backgrounds/` + file
        )
      }) // Get background images

      FabricService.getImages().then((response) => {
        this.imageList = response.data.files.map(
          (file) => `${config.backendURL}/public/sprites/` + file
        )
      }) // Get sprite images

      // Update system variables to currently selected object
      this.canvas.on('selection:updated', (e) => this.updateVariables(e)) // Updates the right settings screen when selecting different elements
      this.canvas.on('selection:created', (e) => this.updateVariables(e)) // Updates the right settings screen when selecting different elements
      // If there is no selection on the canvas, set the active settings on the right side of the screen to 'canvas'
      this.canvas.on('selection:cleared', () => {
        this.activeSettings = 'canvas'
        this.showIcon()
      })
      // Calculate chip size on every added or removed item
      this.canvas.on('object:added', () => this.calculateBytes())
      this.canvas.on('object:removed', () => this.calculateBytes())
      this.canvas.on('path:created', () => {
        // Listen for a path being completed on the canvas then initate an undoSave
        this.initiateSave(100)
      })
      this.canvas.on('object:modified', () => {
        // Listen for an object being modified and initiate an undoSave
        this.initiateSave(100)
      })

      // Fire whenever the mouse is moved on the canvas.
      // Sets the mouseX and mouseY variables
      this.canvas.on('mouse:move', (e) => {
        mouseX = e.absolutePointer.x
        mouseY = e.absolutePointer.y
      })

      // Detect the user clicking outside of the canvas
      // De-select the item inside the canvas if so
      document.body.onmousedown = function(e) {
        if (e.srcElement.id == 'clickable') {
          self.canvas.discardActiveObject()
          self.canvas.renderAll()
        }
      }
      // Detect all keypresses from the user
      window.addEventListener('keydown', function(e) {
        if (e.key == 'Delete') {
          // If user presses the 'delete' key
          self.deleteElement()
        } else if (e.key == 'c' && e.ctrlKey == true) {
          // If user presses CTRL + C
          // Copies the canvas to clipboard
          clipboard =
            self.canvas.getActiveObjects().length >= 1 ? self.canvas.getActiveObjects() : []
        } else if (e.key == 'v' && e.ctrlKey == true && clipboard.length != 0) {
          // If user presses CTRL + V
          if (clipboard.length == 1) {
            // Pastes the clipboard contents
            clipboard[0].clone(function(cloned) {
              cloned.set({ left: mouseX, top: mouseY })
              self.canvas.add(cloned)
            })
          } else {
            clipboard.forEach((obj) => {
              obj.clone(function(cloned) {
                cloned.set({ left: mouseX, top: mouseY })
                self.canvas.add(cloned)
              })
            })
          }
          self.canvas.renderAll()
        } else if (e.key == 'z' && e.ctrlKey == true) {
          undoFunction() // Trigger undo function
        } else if (e.key == 'y' && e.ctrlKey == true) {
          redoFunction() // Trigger redo function
        }
      })
      this.getTemplateList()
    },
    async resize() {
      this.viewportSize = [
        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
      ]
      if (
        this.viewportSize[0] < 1641 &&
        this.enableSizeWarning == true &&
        this.sizeWarningDialog == false
      ) {
        this.sizeWarningDialog = true
      } else if (this.enableSizeWarning == false && this.sizeWarningDialog == true) {
        this.sizeWarningDialog = false
      } else if (this.viewportSize[0] > 1640 && this.enableSizeWarning == true) {
        this.sizeWarningDialog = false
      }
    },
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser',
    }),
    color: {
      get() {
        return this[this.type]
      },
      set(v) {
        this[this.type] = v
      },
    },
  },
  watch: {
    fontSearch: function() {
      const regex = new RegExp(this.fontSearch, 'i')
      if (this.fontSearch != '') {
        this.searchedFontArray = this.fontArray.filter(({ name }) => {
          return name.match(regex)
        })
      } else {
        this.searchedFontArray = this.fontArray
        this.fontMenu = true
      }
    },
    color: function() {
      if (typeof this.color === 'string') this.changeColor(this.color)
    },
    brushMode: function() {
      this.changeBrushMode()
    },
    fontSettings: {
      handler: function() {
        this.modifyTextbox()
      },
      deep: true,
    },
    fontFeatures: function() {
      this.modifyTextbox()
    },
  },
  mounted() {
    // Startup functions
    this.setupFonts()
    this.checkLogin() // Check if user is logged in
    this.startUp()
    this.resize()
    ItemService.getChipCount({ token: this.getUser.token })
      .then((response) => {
        this.maxChips = response.data.max
        this.chips = response.data.chips
        this.chipWarning = true
      })
      .catch((error) => {
        this.$store.dispatch('setAlert', error)
      })

    window.onbeforeunload = function() {
      // Detect refresh page or changing navigation and cancel it if on the 'create' route
      return ''
    }
    window.addEventListener('resize', () => {
      this.resize()
    })

    // Detect if user is using different web browsers
    var isChromium = window.chrome
    var winNav = window.navigator
    var vendorName = winNav.vendor
    var isOpera = typeof window.opr !== 'undefined'
    var isIEedge = winNav.userAgent.indexOf('Edge') > -1
    var isIOSChrome = winNav.userAgent.match('CriOS')
    let isChrome = false
    if (isIOSChrome) {
      isChrome = true
    } else if (
      isChromium !== null &&
      typeof isChromium !== 'undefined' &&
      vendorName === 'Google Inc.' &&
      isOpera === false &&
      isIEedge === false
    ) {
      isChrome = true
    } else {
      isChrome = false
    }
    if (!isChrome) {
      this.chromeWarning = true
    }
  },
  components: {
    FSModal,
    Modal,
  },
  props: {
    itemInfo: Object,
  },
}
</script>

<style>
.small-checkbox {
  margin: 0px;
  padding: 0px;
}

.size-warning {
  color: red;
  background: transparent;
}

.flex-container {
  height: auto;
  width: 100%;
  margin: auto;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
}

.settings-element {
  margin-bottom: 12px;
  width: 700px;
  height: 720px;
  order: 0;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: flex-start;
  word-wrap: break-word;
  margin-left: auto;
  margin-right: auto;
}

/* Left container */

.left-container {
  margin-bottom: 12px;
  height: 725px;
  width: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
}

.side-settings-element {
  width: 250px;
  margin-right: 12px;
  margin-left: 12px;
  height: 100%;
}

.canvas-container {
  position: relative;
  order: 0;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: auto;
  width: 650px;
  height: 725px;
}

.canvas-element {
  order: 0;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: auto;
  border-radius: 50%;
}

#canvas-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  opacity: 0.85;
  pointer-events: none;
}

#canvas-overlay-image {
  width: 100%;
  pointer-events: none;
}

.toolbar-nav {
  display: flex;
}

.toolbar-item {
  display: inline-block;
  margin: auto;
}

.settings-card {
  width: 95%;
  height: 100%;
  margin: auto;
}

/* -------------------- */

.div-container {
  margin-right: 12px;
  margin-left: 12px;
}

/* Image Container and items */

.image-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  height: auto;
  width: 100%;
}

.image-item {
  margin: 10px;
  order: 0;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  align-self: auto;
}

.overlay-chip {
  position: absolute;
  width: 100%;
  z-index: 2;
}

.overlay-image {
  border-radius: 50%;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 70%;
  z-index: 1;
}

.overlay-box {
  position: relative;
  height: 160px;
  width: 160px;
  margin-left: auto;
  margin-right: auto;
}

@page {
  size: 17in 22in;
  margin: 0mm;
}
</style>
